import { useNavigate } from 'react-router';
import type { TrialKind } from '@/shared/utils/trial-quota';
import { useTrialQuotaNotice } from '../../hooks/useTrialQuotaNotice';
import { TrialQuotaNoticeView } from './TrialQuotaNoticeView';

interface Props {
  agencyId: string;
  kind: TrialKind;
  /** Show the block even if usage says otherwise: the server answered 402. */
  forceBlock?: boolean;
}

/**
 * The trial-ceiling notice for one quota, wired to the agency's data.
 *
 * Renders nothing outside the trial or below 80%. The button goes to the
 * Assinatura tab, where activation lives.
 *
 * @param props - The agency, the quota, and whether the server already said no.
 * @returns The notice, or null.
 */
export function TrialQuotaNotice({ agencyId, kind, forceBlock = false }: Props) {
  const navigate = useNavigate();
  const model = useTrialQuotaNotice(agencyId, kind, forceBlock);
  if (!model) return null;
  return (
    <TrialQuotaNoticeView
      model={model}
      onActivate={() => navigate(`/app/agencies/${agencyId}/settings?section=plano`)}
    />
  );
}
